import { closeOverlay } from "../blocks/overlay";
import { $BODY, BODY_LOCK_CLASS } from "../lib/constants";

const closeBonusImgsOverlay = () => {
  const $closeBtn = $(".js-bonus-imgs-close-btn");

  $closeBtn.on("click", function () {
    closeOverlay();
    $BODY.removeClass(BODY_LOCK_CLASS);
  });
};

const showCurrentSelectOptionByBoilerModeTabPress = () => {
  const $serviceShell = $(".js-service");
  const $boilerTabs = $serviceShell.find("[data-tab]");
  const $selectOptions = $(".js-service-contact-form").find("[data-type]");

  const showOptions = ($selectOptions, type) => {
    $.each($selectOptions, function (_, el) {
      const $el = $(el);

      if ($el.attr("data-type") === type) {
        $el.show();
      }
    });
  };

  $boilerTabs.on("click", function () {
    const $tab = $(this);

    $selectOptions.hide();

    if ($tab.attr("data-tab") === "industrial") {
      showOptions($selectOptions, "1");
    }

    if ($tab.attr("data-tab") === "household") {
      showOptions($selectOptions, "4");
    }
  });
};

export const serviceFns = () => {
  closeBonusImgsOverlay();
  showCurrentSelectOptionByBoilerModeTabPress();
};
